<template>
  <div class="mainwrap">
    <div v-if=" orderSystem == '1'" >
    
    <div class="tune-widget-mainbar">
      <div class="tune-widget-mainbar-l">
          <logo-link :logo="img1" :link="siteLinkout"/>
        <!-- <img :src="img1" class="header-image" alt="start image" /> -->
      </div>
      <div class="tune-widget-mainbar-m">{{ $t("rica_shop") }}</div>
      <div class="tune-widget-mainbar-r">&nbsp;</div>
    </div>

    
      <form autocomplete="false">
        <div class="main-header" >{{ $t("checkout") }}</div>
    <div class="shop-results">

      <div v-if="shoppingCart.length > 0">  

     

        <!-- summary mobile -->
      <div class="shop-row-split hideDesktop" style="text-align: left">
          <div class="checkout-order-summary">
            <div class="" style="text-align: center">
               <div class="generic-form-row" >
                <div class="checkout-col-field shop-header" style="width:50%;text-align:left;">{{ $t("order_summary") }}</div>
                <div class="checkout-col-field" style="width:50%;text-align:right;"><a href="/shop" style="text-decoration: underline;">{{ $t("edit_cart") }}</a></div>
              </div>
            </div>
            <div class="generic-form-row" ><hr /></div>            
            <div class="generic-form-row" v-for="product in shoppingCart" v-bind:key="product.ProductID" >
              <div class="shop-item-col" style="width: 10%; text-align: left">
                 <b>{{ product.amount }}x</b>
              </div>
              <div class="shop-item-col" style="width: 60%; text-align: left">
                {{ product.ProductName }} - {{ product.Category }}
              </div>
              <div class="shop-item-col" style="width: 30%; text-align: right">


                <div v-if="product.ProductCode == '50p' && this.hasStagingProduct">
                    <div style="float:left;width:100%;text-decoration:line-through;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount)}}</div>
                    <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice((custom_fixUglyPrice(product.Price)/2)*product.amount) }}</div>
                </div>
                <div v-else>
                      <div v-if="product.DiscountDescription && product.ProductCode != '50p'">
                        <div style="float:left;width:100%;text-decoration:line-through;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price))}}</div>
                        <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(extractDiscount(product.DiscountDescription))) }}</div>
                    </div>
                      <div v-else>
                        &euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount)}} 
                    </div>
                </div>


              </div>
              <div class="generic-form-row" ><hr /></div>
              
            </div>

           <div class="generic-form-row" >
              <div class="checkout-col-field" style="width:70%;text-align:left;"><b>{{ $t("subtotal_incvat") }}</b></div>
              <div class="checkout-col-field" style="width:30%;text-align:right;"><b>&euro; {{ formatPrice(cartTotal) }}</b></div>
            </div>


            <div  >
              <div class="generic-form-row" >
                <div class="checkout-col-field" style="width:70%;text-align:left;"><b>{{ $t("total_weight") }}</b></div>
                <div class="checkout-col-field" style="width:30%;text-align:right;">
                  <div v-if="chargeShipping == true">
                  <b>&lt; 1 kg</b>
                    </div>
                    <div v-else>
                      0 
                    </div>
                  </div>
              </div>

              <div class="generic-form-row" v-if="extraDiscount['amount'] > 0">
                <div class="checkout-col-field" style="width:70%;text-align:left;"><b>{{ extraDiscount["name"][locale] }}</b></div>
                <div class="checkout-col-field" style="width:30%;text-align:right;"><b>- &euro; {{ formatPrice(extraDiscount["amount"]) }}</b></div>
              </div>

              <div class="generic-form-row" >
                <div class="checkout-col-field" style="width:70%;text-align:left;"><b>{{ $t("shipping") }}</b></div>
                <div class="checkout-col-field" style="width:30%;text-align:right;">
                  <div v-if="shippingTotal == ''" class="red-orange-text">
                    {{ $t("select_country") }}
                  </div>
                  <div v-else>
                    <div v-if="chargeShipping == true">
                      <b>&euro; {{ formatPrice(shippingTotal) }}</b>
                    </div>
                    <div v-else>
                      0
                    </div>

                  </div>
                </div>
              </div>

                <div class="generic-form-row" ><hr /></div>

            <div class="generic-form-row"  v-if=" shippingTotal != ''">
              <div class="checkout-footer-field" style="width:60%;text-align:left;"><b>{{ $t("total_incvat") }}</b></div>
              <div class="checkout-footer-field" style="width:40%;text-align:right;"><b>&euro; {{ formatPrice(grandTotal) }}</b></div>
            </div>
            
            </div>
         
        </div>
          <div class="generic-form-row" >&nbsp;</div>
      </div>
      <!-- end summary mobile -->


      <div class="shop-row-split" style="text-align: left">


    
        <!-- // Customer name -->
        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("name") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              id="customer_name"
              name="customer_name"
              placeholder=""
              :value="curOrder.name"
              @input="updateCheckoutForm"
            />
          </div>
        </div>

        <!-- Email address -->
        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("email") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              id="customer_email"
              name="customer_email"
              placeholder=""
              :value="curOrder.email"
              @input="updateCheckoutForm"
            />
          </div>
        </div>

        <!-- Email address -->
        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("phone") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              id="customer_phone"
              name="customer_phone"
              placeholder=""
              :value="curOrder.phone"
              @input="updateCheckoutForm"
            />
          </div>
        </div>

        <!-- // Shipping address -->
        <div class="generic-form-row">
          <div class="generic-form-label" style="width: 100%">
            {{ $t("address_and_nr") }} <span style="color:#DF2F00;vertical-align:top; ">*</span>
          </div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              id="shipping_address"
              name="shipping_address"
              placeholder=""
              :value="curOrder.shipping_address"
              @input="updateCheckoutForm"
            />
       
          </div>
        </div>


        <!-- // Shipping zip + city -->
        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("zip_and_residence") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
          <div class="generic-form-value">
                 <input
              type="text"
              class="default-input"
              style="float: left; width: 28%"
              id="shipping_zip"
              name="shipping_zip"
              placeholder=""
              :value="curOrder.shipping_zip"
              @input="updateCheckoutForm"
            />
            <input
              type="text"
              class="default-input"
              style="float: right; width: 69%;"
              id="shipping_city"
              name="shipping_city"
              placeholder=""
              :value="curOrder.shipping_city"
              @input="updateCheckoutForm"
            />
          </div>
        </div>
        <!-- // Shipping country -->

        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("country") }} {{ curOrder.shipping_country }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
          <div class="generic-form-value" style="line-height: 2vh">


            <!-- <select id="shipping_country" @change="recalculateShipping($event.target.value)"  @input="updateCheckoutForm" v-model="curOrder.shipping_country" class="default-input"> -->
            <!-- <select id="shipping_country"  @input="updateCheckoutForm" v-model="curOrder.shipping_country" class="default-input"> -->
            <select id="shipping_country" v-model="curOrder.shipping_country"  @input="updateCheckoutForm" class="default-input">
              <option value="">{{ $t("country") }}</option>                
              <option v-for="(val, key) in Object.entries(countries)"  v-bind:key="key[0]" v-bind:value="val[0]">
                  {{ val[1] }}
              </option>
            </select>
          </div>
        </div>




        <!-- // License plate -->
        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("license_plate") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              id="customer_licenseplate"
              name="customer_licenseplate"
              placeholder=""
              :value="curOrder.license_plate"
              @input="updateCheckoutForm"
            />
          </div>
        </div>
        <!-- // Chassis number -->
        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("chassis_vin") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              id="customer_chassisno"
              name="customer_chassisno"
              placeholder=""
              :value="curOrder.chassisno"
              @input="updateCheckoutForm"
            />
          </div>
        </div>

        <!-- // Additional info / notes -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("note") }}</div>
            <div class="generic-form-"><textarea class="default-input-textarea" style="height:150px;" id="customer_note" name="customer_note" placeholder="" :value="curOrder.note"
              @input="updateCheckoutForm"></textarea></div>
        </div>                



        <!-- // Alternate billing address -->
        <div class="generic-form-row">
          <div class="generic-form-label-checkbox" style="">
            <input
              id="has_alt_address"
              name="has_alt_address"
              class="default-checkbox"
              type="checkbox"
              @click="toggleAltAddress($event)"
              @input="updateCheckoutForm"
            />
          </div>
          <div class="generic-form-label" style="width: 90%">
            {{ $t("dif_billing_address") }}
          </div>
        </div>

        <!-- // hide by default -->
        <div
          id="alt_address_block"
          name="alt_address_block"
          style="display: none"
        >
          <!-- // Alternative Billing address + zip -->
  






           <!-- // Shipping address -->
        <div class="generic-form-row">
          <div class="generic-form-label" style="width: 100%">
            {{ $t("address_and_nr") }}
          </div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              id="billing_address"
              name="billing_address"
              placeholder=""
              :value="curOrder.billing_address"
              @input="updateCheckoutForm"
            />
       
          </div>
        </div>


        <!-- // Shipping zip + city -->
        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("zip_and_residence") }}</div>
          <div class="generic-form-value">
            <input
              type="text"
              class="default-input"
              style="float: left; width: 28%"
              id="billing_zip"
              name="billing_zip"
              placeholder=""
              :value="curOrder.billing_zip"
              @input="updateCheckoutForm"
            />
            <input
              type="text"
              class="default-input"
              style="float: right; width: 69%;"
              id="billing_city"
              name="billing_city"
              placeholder=""
              :value="curOrder.billing_city"
              @input="updateCheckoutForm"
            />
          </div>
        </div>
        <!-- // Shipping country -->

        <div class="generic-form-row">
          <div class="generic-form-label">{{ $t("country") }}</div>
          <div class="generic-form-value" style="line-height: 2vh">


            <select id="billing_country" @change="recalculateShipping($event.target.value)" @input="updateCheckoutForm" v-model="curOrder.billing_country" class="default-input">
            <!-- <select id="billing_country"  v-model="curOrder.billing_country" class="default-input"> -->
              <option value="">{{ $t("country") }}</option>                
              <option v-for="(val, key) in Object.entries(countries)"  v-bind:key="key[0]" v-bind:value="val[0]">
                  {{ val[1] }}
              </option>
            </select>
          </div>
        </div>










        </div>

        <div class="generic-form-row" >&nbsp;</div>
        <div class="generic-form-row" >
            <div class="form-button-wrapper-50" style="float:left;">
              <div class="tune-action-button" @click="this.$router.push('shop')">{{ $t("go_back") }}</div>
            </div>
            <div class="form-button-wrapper-50" style="float:left;padding-left:14px;">
              <div class="tune-action-button" @click="gotoPayment()"  v-if=" shippingTotal != ''">{{ $t("goto_payment") }}</div>
            </div>
        </div>
        
      </div>

      <!-- summary desktop -->
      <div class="shop-row-split hideMobile" style="text-align: right">
           <div class="shop-header">&nbsp;</div>
        <div v-if="shoppingCart.length > 0">  
          <div class="checkout-order-summary">
            <div class="checkout-details-header" >
                <div class="checkout-details-header-l">{{ $t("order_summary") }}</div>
                <div class="checkout-details-header-r"><a href="/shop" style="text-decoration: underline;">{{ $t("edit_cart") }}</a></div>
            </div>
            <div class="generic-form-row" ><hr /></div>            
            <div class="generic-form-row" v-for="product in shoppingCart" v-bind:key="product.ProductID" >
              <div class="shop-item-col" style="width: 10%; text-align: left">
                 <b>{{ product.amount }}x</b>
              </div>
              <div class="checkout-col-field" style="width: 60%; text-align: left">
                {{ product.ProductName }} - {{ product.Category }}
              </div>
              <div class="shop-item-col" style="width: 30%; text-align: right">


     
                <div v-if="product.DiscountDescription ">
                    <div style="float:left;width:100%;text-decoration:line-through;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount)}}</div>
                </div>
                <div v-else>
                    <div style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount)}}</div>
                </div>
                
                
                <div v-if="product.ProductCode == '50p' && this.hasStagingProduct">
                      <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)/2*product.amount)  }}</div>
                </div>
                <div v-else>
                    <div v-if="product.DiscountDescription ">
                        <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(extractDiscount(product.DiscountDescription))*product.amount)  }}</div>
                    </div>
                </div>
                <!-- <b>&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount) }}</b> -->
              </div>
              <div class="generic-form-row" ><hr /></div>
              
            </div>

            <div class="generic-form-row" >
              <div class="checkout-col-field" style="width:50%;text-align:left;"><b>{{ $t("subtotal_incvat") }}</b></div>
              <div class="checkout-col-field" style="width:50%;text-align:right;"><b>&euro; {{ formatPrice(cartTotal) }}</b></div>
            </div>


            <div  >
              <div class="generic-form-row" >
                <div class="checkout-col-field" style="width:50%;text-align:left;"><b>{{ $t("total_weight") }}</b></div>
                <div class="checkout-col-field" style="width:50%;text-align:right;">
                  <div v-if="chargeShipping == true">
                  <b>&lt; 1 kg</b>
                    </div>
                    <div v-else>
                      0 
                    </div>
                  </div>
              </div>

              <div class="generic-form-row" v-if="extraDiscount['amount'] > 0">
                <div class="checkout-col-field" style="width:60%;text-align:left;"><b>{{ extraDiscount["name"][locale] }}</b></div>
                <div class="checkout-col-field" style="width:40%;text-align:right;"><b>- &euro; {{ formatPrice(extraDiscount["amount"]) }}</b></div>
              </div>

              <div class="generic-form-row" >
                <div class="checkout-col-field" style="width:50%;text-align:left;"><b>{{ $t("shipping") }}</b></div>
                <div class="checkout-col-field" style="width:50%;text-align:right;">
                  <div v-if="shippingTotal == ''" class="red-orange-text">
                    {{ $t("select_country") }}
                  </div>
                  <div v-else>
                    <div v-if="chargeShipping == true">
                      <b>&euro; {{ formatPrice(shippingTotal) }}</b>
                    </div>
                    <div v-else>
                      0
                    </div>

                  </div>
                </div>
              </div>
            </div>


            <!-- <div v-if="discountTotal > 0 && shippingTotal != ''">
              <div class="shop-total-row" >
                  <div class="checkout-col-field" style="width:50%;text-align:left;">{{ $t("discount") }}</div>
                  <div class="checkout-col-field" style="width:50%;text-align:center;"><b>- &euro; {{ formatPrice(discountTotal) }}</b></div>
              </div>

                <div class="shop-total-row" >
                  <div class="checkout-col-field" style="width:50%;text-align:left;">{{ discountName }}</div>
                  <div class="checkout-col-field" style="width:50%;text-align:center;"></div>

              </div>
            </div> -->
            <div class="generic-form-row" ><hr /></div>

            <div class="generic-form-row"  v-if=" shippingTotal != ''">
              <div class="checkout-footer-field" style="width:50%;text-align:left;"><b>{{ $t("total_incvat") }}</b></div>
              <div class="checkout-footer-field" style="width:50%;text-align:right;"><b>&euro; {{ formatPrice(grandTotal) }}</b></div>
            </div>
          </div>
        </div>
      </div>
      <!-- end summary desktop -->

      <!-- form -->
    </div>
    <div v-else>
      <!-- <div class="shop-item-row" ><hr /></div> -->
      <div class="generic-form-row" >{{ $t("cart_empty") }}</div>

      <div class="generic-form-row" >&nbsp;</div>

      <div class="" style="text-align:center;padding:30px;">
          <div class="tune-action-button" style="width:155px;display:inline-block;" @click="this.$router.push('/')">{{ $t("back_to_home") }}</div> 
      </div> 
     </div>
     </div>
      </form>

    <!-- end shop results -->
    <!-- <bottom-bar /> -->

      </div>
        <div v-else>
            Order system not active
        </div>

  </div>
  <!-- end mainwrap -->
</template>

<script>
import axios from "axios";


const methods = {
  toggleAltAddress(event) {
    var elem = document.getElementById("alt_address_block");
    if (event.target.checked) {
      elem.style.display = "inline-block";
    } else {
      elem.style.display = "none";
    }
  },
  recalculateShipping(value) {
    // this.validateOrderForm(); 
    // return false;
    // var sel_country = document.getElementById("" + elem).value;
    var sel_country = value;
    // getShippingFee
    var par = this;
    var weight = 0.2;
    var variantsURL = this.apiHost+"?ep=getShippingFee&country="+sel_country+"&weight=" + weight;
    axios.get(variantsURL)
    .then(function(response) {
        if(response.data.result != "") {
          if(response.data.result != null) {
            // par.chargeShipping = true;
            par.shippingTotal = parseFloat(response.data.result);
          } else {
            par.shippingTotal = "";
          }
        } else {
            par.shippingTotal = 0;
        }
    })
    .catch(function (error) {
        console.log(error);
    })
  },
  custom_fixUglyPrice: function (price) {
    // in cents/units!
    if (price == "" || price == undefined) {
      price = "0";
    }
    var priceInt = price.replace("+ VAT", "");
    priceInt = priceInt.replace("€", "");
    priceInt = priceInt.split(" ")[0];
    return priceInt;
  },
  formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  },
  gotoPayment() {
    var formValid = this.validateOrderForm();
    if (formValid["status"] == "success") {
      this.$router.push("payment");
    } else {
      alert(formValid["msg"]);
    }
  },
  updateCheckoutForm() {
    console.log("updateCheckoutForm: orderid=" + this.curOrder.orderid);
    this.recalculateShipping(document.getElementById("shipping_country").value);
    this.validateOrderForm()
  },
  validateOrderForm() {
    console.log("validateOrderForm: orderid=" + this.curOrder.orderid);    
    var result = Array();
    result["status"] = "success";
    var email = document.getElementById("customer_email").value;
    var phone = document.getElementById("customer_phone").value;
    var name = document.getElementById("customer_name").value;
    var chassis_number = document.getElementById("customer_chassisno").value;
    var license_plate = document.getElementById("customer_licenseplate").value;
    var shipping_address = document.getElementById("shipping_address").value;
    var shipping_zip = document.getElementById("shipping_zip").value;
    var shipping_city = document.getElementById("shipping_city").value;
    var shipping_country = document.getElementById("shipping_country").value;
    var customer_note = document.getElementById("customer_note").value;
    // billing
    var alt_billing = document.querySelector("#has_alt_address").checked;
    var billing_address = document.getElementById("billing_address").value;
    var billing_zip = document.getElementById("billing_zip").value;
    var billing_city = document.getElementById("billing_city").value;
    var billing_country = document.getElementById("billing_country").value;
    var missingFields = window.curStrings["fill_in_fields"] + ": \n";
    if (email == "") {
      result["status"] = "failed";
      missingFields += "* " + window.curStrings["email"] + "\n" ;
    }
    if (phone == "") {
      result["status"] = "failed";
      missingFields += "* " + window.curStrings["phone"] + "\n" ;
    }    
    if (name == "") {
      result["status"] = "failed";
      missingFields += "* " + window.curStrings["name"] + "\n";
    }
    if (chassis_number == "") {
      result["status"] = "failed";
        missingFields += "* " + window.curStrings["chassis_nr"] + "\n";
    }
    if (shipping_address == "") {
      result["status"] = "failed";
        missingFields += "* " + window.curStrings["address"] + "\n";
    }
    if (shipping_zip == "") {
      result["status"] = "failed";
        missingFields += "* " + window.curStrings["zipcode"] + "\n";
    }
    if (shipping_city == "") {
      result["status"] = "failed";
        missingFields += "* " + window.curStrings["city"] + "\n";
    }
    if (shipping_country == "") {
      result["status"] = "failed";
      missingFields += "* " + window.curStrings["country"] + "\n";
    }

    // make billing address mandatory if checked
    if(alt_billing) {
      if (billing_address == "") {
        result["status"] = "failed";
        missingFields += "* " + window.curStrings["country"] + "\n";
      }
      if (billing_zip == "") {
        result["status"] = "failed";
        missingFields += "* " + window.curStrings["zipcode"] + "\n";
      }
      if (billing_city == "") {
        result["status"] = "failed";
        missingFields += "* " + window.curStrings["city"] + "\n";
      }
      if (billing_country == "") {
        result["status"] = "failed";
        missingFields += "* " + window.curStrings["country"] + "\n";
      }
    }

    var orderDetails = {};
    orderDetails["email"] = email;
    orderDetails["phone"] = phone;
    orderDetails["name"] = name;
    orderDetails["license_plate"] = license_plate;
    orderDetails["chassisno"] = chassis_number;
    orderDetails["shipping_address"] = shipping_address;
    orderDetails["shipping_zip"] = shipping_zip;
    orderDetails["shipping_city"] = shipping_city;
    orderDetails["shipping_country"] = shipping_country;

    orderDetails["alt_billing"] = alt_billing;
    orderDetails["billing_address"] = billing_address;
    orderDetails["billing_zip"] = billing_zip;
    orderDetails["billing_city"] = billing_city;
    orderDetails["billing_country"] = billing_country;
    orderDetails["note"] = customer_note;
    
    var cartList = [];
    for (var i = 0; i < this.shoppingCart.length; i++) {
      cartList.push(this.shoppingCart[i]);
    }
    orderDetails["cart"] = cartList;
    orderDetails["cart_total"] = this.grandTotal;
    orderDetails["orderid"] = this.curOrder.orderid;
    orderDetails["order_lang"] =  this.$i18n.locale ;

    this.$store.commit("saveOrderDetails", orderDetails);

    result["msg"] = missingFields;
    return result;
  },
};
export default {
  data() {
    this.$i18n.locale =  this.$store.state.curLanguage
    var curLocale = this.$i18n.locale;

    window.curStrings = this.$i18n.messages[this.$i18n.locale];
  
    var shippingTotal = 10;

    var discountName = "";

    var countries = {};
    var apiHost = process.env.VUE_APP_RICA_API_HOST;
    return {
      img1: require("./../assets/header-logo.png"),
      apiHost: apiHost,
      shippingTotal: shippingTotal,

      countries: countries,

      discountName:discountName,
      locale:curLocale
    };
  },
methods: methods,
computed: {
    orderSystem: function () {
        return this.$store.state.orderSystem;
    },
    curOrder: function () {
      return this.$store.state.curOrder;
    },

  },
  mounted() {
    var par = this;

    // if (this.curOrder.billing_address != "" && this.curOrder.billing_address != undefined) {
    if (this.curOrder.alt_billing) {
      var elem = document.getElementById("alt_address_block");
      document.getElementById("has_alt_address").checked = true;
      elem.style.display = "inline-block";
    }
    var countriesURL = this.apiHost + "?ep=countries";
    axios
      .get(countriesURL)
      .then(function (response) {
        par.countries = response.data;

      })
      .catch(function (error) {
        console.log(error);
      });
       this.$nextTick(function () {
      //   par.recalculateShipping(par.curOrder.shipping_country)
      //   par.validateOrderForm()
          // par.toggleAltAddress()
        })
  },
  
  components: {
    "bottom-bar": require("@/components/BottomBar.vue").default,
    'logo-link': require('@/components/LogoLink.vue').default,
  },
};
</script>

<style>
</style>